import React, { useEffect, useState } from 'react';
import photo4 from '../img/IMG20240226164202.jpg';

const ThanksModal: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if the URL has the query parameter `gift=true`
    const params = new URLSearchParams(window.location.search);
    if (params.get('gift') === 'true') {
      setIsModalOpen(true);
      // Clean up the query parameters after showing the modal
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, []);

  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-3xl font-bold text-[#B94665] hover:text-[#9c3b57] focus:outline-none"
              onClick={closeModal}
            >
              &times;
            </button>
            <h2 className="text-4xl font-serif text-[#B94665] mb-4">
              ¡Gracias!
            </h2>
            <p className="text-gray-700 text-lg">
              ¡Muchísimas gracias por tu generosidad y cariño! Nos llena de
              alegría saber que compartes este momento tan especial con
              nosotros. ¡Nos vemos en la boda para celebrarlo juntos!
            </p>
            <div className="mt-6">
              <img
                src={photo4}
                alt="Thank you"
                className="rounded-lg shadow-md w-full"
              />
            </div>
            <button
              className="mt-6 px-6 py-3 bg-[#B94665] text-white font-semibold rounded-lg hover:bg-[#9c3b57] transition-colors"
              onClick={closeModal}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ThanksModal;
